import React from 'react'
import { PageProps } from 'gatsby'

// Lazy loading
import loadable from '@loadable/component'

export interface PostsProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location?: PageProps['location']
  slider?: boolean
}

interface PostProps {
  [key: string]: any
}

const PostsShell: React.FC<PostsProps> = ({ fields, location }) => {
  const types: PostProps = {
    overview: loadable(() => import('components/flex/Posts/Overview')),
    latest: loadable(() => import('components/flex/Posts/Latest')),
    other: loadable(() => import('components/flex/Posts/Highlighted')),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default PostsShell
